import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AccountProvider"] */ "/opt/build/repo/src/contexts/AccountContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/build/repo/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalBalanceProvider"] */ "/opt/build/repo/src/contexts/GlobalBalanceContext.tsx");
